<h5 class="mb-0"> 
  <a href="javascript:;" class="btn btn-sm btn-primary btn-round btn-icon" (click)="onBackToEmailConfigurations()"><i class="nc-icon nc-minimal-left"></i></a>
  <a href="javascript:;" class="btn btn-sm btn-outline-primary btn-round btn-icon ml-1" (click)="onAddNewTemplate()" data-toggle="modal" data-target="#mdlEmailTemplate"><i class="nc-icon nc-simple-add"></i></a>
  Templates for: <span class="text-primary"><strong>{{emailConfigSelected?.fromEmail}}</strong></span>
</h5>
<div class="mb-3">
  <small class="text-muted">{{currentApiKey}}</small>
</div>
<div class="table-responsive">
  <table class="table">
    <thead class=" text-primary">
      <th>
        ID
      </th>
      <th>
        Code
      </th>
      <th>
        Title
      </th>
      <th>
        Short Description
      </th>
      <th class="text-right">
        ...
      </th>
    </thead>
    <tbody>
      <tr *ngFor="let t of templates">
        <td style="width: 5%">
          {{t.id}}
        </td>
        <td style="width: 15%">
          {{t.code}}
        </td>
        <td style="width: 20%">
          {{t.title}}
        </td>
        <td>
          {{t.shortDescription}}
        </td>
        <td class="text-right">
          <a href="javascript:;" (click)="onEditEmailTemplate(t)" data-toggle="modal" data-target="#mdlEmailTemplate" class="btn btn-sm btn-outline-info btn-round btn-icon" ><i class="fa fa-pencil"></i></a>
        </td>
      </tr>
    </tbody>
  </table>
</div>      
